import useTranslation from 'next-translate/useTranslation'
import { useContext } from 'react'

import OperationInput from '../components/OperationInput'

import { MetronomeContext } from './MetronomeContext'

const SupplyCollateral = function ({
  amountIsZero,
  assetIsInactive,
  availableCollaterals,
  isStopped,
  noSupply,
  noSyntheticSupply,
  notEnoughBalance,
  syntheticIsInactive,
  userBalance
}) {
  const { t } = useTranslation()
  const {
    collateralBalances,
    inputValue,
    selectedToken,
    setInputValue,
    setSelectedToken
  } = useContext(MetronomeContext)

  const disabledOperation =
    assetIsInactive ||
    isStopped ||
    noSupply ||
    noSyntheticSupply ||
    syntheticIsInactive

  const userCollateralTokens = availableCollaterals.map(userCollateral => ({
    ...userCollateral,
    ...collateralBalances[userCollateral.address]
  }))

  return (
    <div className="bg-blue-secondary rounded-lg p-4">
      <span className="text-lg font-medium">{t('supply-collateral')}</span>
      <OperationInput
        availableTokens={userCollateralTokens || []}
        balancePrefix={t('wallet')}
        chooseLabel={t('choose-collateral')}
        disableInput={disabledOperation}
        disableSelector={isStopped}
        disableWithoutBalance={false}
        inputValue={inputValue}
        onChange={amount => setInputValue(amount)}
        onTokenChange={setSelectedToken}
        selectedToken={selectedToken}
        userAssetBalance={userBalance}
      >
        <div
          className={`bg-blue-5 mt-6 rounded-lg border px-4 pb-3 pt-4 ${
            !!inputValue && amountIsZero ? 'border-red-600' : 'border-blue-5'
          }`}
        >
          <div className="flex justify-between">
            <OperationInput.Input />
            <OperationInput.TokenSelector
              disableWithoutBalance={false}
              displayTokenBalances
              itemsListClassName="overflow-y-auto max-h-130"
            />
          </div>
          <div className="text-gray-4 mt-2 flex items-center justify-between text-sm leading-6">
            <OperationInput.ValueInUsd />
            <div className="flex gap-2 font-sans">
              <OperationInput.Balance isInvalid={notEnoughBalance} />
              <OperationInput.MaxSelector />
            </div>
          </div>
        </div>
      </OperationInput>
    </div>
  )
}

export default SupplyCollateral
